// @flow
import { call, put, takeLatest } from "redux-saga/effects";
import API from "api";

import * as ActionTypes from 'constants/ActionTypes';
import * as Actions from "actions";

function* adminGetSystemUsage(action: Object) {
  try {
    const response = yield call(() => API.get('/admin/virtual-tryon/system-usage'));
    
    if (response && response.response) {
      yield put(Actions.adminGetSystemUsageSuccess(response.response));
    } else {
      yield put(Actions.adminGetSystemUsageFailure("Invalid response format"));
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || "Failed to fetch system usage";
    yield put(Actions.adminGetSystemUsageFailure(errorMessage));
  }
}

export default function* watchAdminSystemUsage() {
  yield takeLatest(ActionTypes.ADMIN_GET_SYSTEM_USAGE_START, adminGetSystemUsage);
}
